import React, { useState, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, IconButton, Stack, Modal, MenuItem, Card, CardContent, Autocomplete, TextField, Select } from '@mui/material';
import { styles, OrderButton, SearchInput } from '../styles';
import { ORDERS } from '../../constant';
import Utils from '../../../../utils/Utils';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAddUserDetails, updateUser } from '../../../../services/Gateway/RestAPIHandler'
import SimpleSnackbar from '../../../../customWidgets/Snackbar';
import { getUserListAction } from '../Store/actions';



function EditLabelUser({ openModal, closeModal, currentPage, userData }) {
    const [open, setOpen] = useState(false);
    const [alertType, setAlertType] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const [countryList, setCountryList] = useState([]);
    const [factoryList, setfactoryList] = useState([]);
    const [group, setGroup] = useState([]);
    const [telephone, setTelephone] = useState('');
    const list = useSelector(state => state.userlist)
    const [emailFactory, setEmailFactory] = useState([]);
    const [groupCode, setgroupCode] = useState('');
    const [age, setAge] = useState('');
    const [country, setCountry] = useState('')
    const dispatch = useDispatch();
    const GRID_FETCH_SIZE = 7;
    const presentPage = 1;
    // const [productgrouplist,setProductgruoplist] = useState(inputData.product);
    const emailNotifyList = ["Y", "N"];
    const emailCodeList = [
        {
            id: "A",
            name: "BOTH"
        },
        {
            id: "1",
            name: "FOOTWEAR"
        },
        {
            id: "2",
            name: "APPAREL"
        },
        {
            id: "0",
            name: "NONE"
        }

    ];

    const [userId, setUserId] = React.useState('');
    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [emailCode, setEmailCode] = React.useState('');
    const [emailNotify, setEmailNotify] = React.useState('');

    /* Values are hardcoded temporarily till get data from API */
    React.useEffect(() => {
        return (dispatch) => {
            fetchAddUserDetails()
                .then(([response, json]) => {
                    if (response.status === 200) {
                        setCountryList(json.results[0].country);
                        setfactoryList(json.results[0].factory);
                        setGroup(json.results[0].userGroup);

                    }
                    else {
                        //  dispatch(getUserListFailure("Unable to fetch User Groups data; Error code - " + json.errorCode));
                    }
                })
        }
    }, [list.order])

    // Populate fields when userData changes
    React.useEffect(() => {
        if (userData) {
            setUserId(userData.userId || '');
            setFirstName(userData.firstName || '');
            setLastName(userData.lastName || '');
            setEmail(userData.email || '');
            setTelephone(userData.telephone || '');
            setCountry(userData.countryName || '');
            setEmailNotify(userData.emailNotify || '');

            // Set group code based on group name
            if (userData.groupName === 'factory_group') {
                setgroupCode('G2');
            } else if (userData.groupName === 'admin_group') {
                setgroupCode('G1');
            }

            // Set email code
            setEmailCode(userData.emailCode || '');

            // Set email factory (convert string to array if needed)
            if (userData.emailFactory) {
                const factoryArray = userData.emailFactory.split(',').filter(f => f.trim() !== '');
                setEmailFactory(factoryArray);
            } else {
                setEmailFactory([]);
            }

            // Show/hide appropriate divs based on user type
            setTimeout(() => {
                if (userData.groupName === 'admin_group') {
                    const emailCodesDiv = document.getElementById("emailCodes");
                    const multipleTagsDiv = document.getElementById("multiple-limit-tags");
                    if (emailCodesDiv) emailCodesDiv.style.display = 'block';
                    if (multipleTagsDiv) multipleTagsDiv.style.display = 'none';
                } else {
                    const emailCodesDiv = document.getElementById("emailCodes");
                    const multipleTagsDiv = document.getElementById("multiple-limit-tags");
                    if (emailCodesDiv) emailCodesDiv.style.display = 'none';
                    if (multipleTagsDiv) multipleTagsDiv.style.display = 'block';
                }
            }, 100);
        }
    }, [userData]);




    const callbackFromMultiSelect = (labels) => {
        setEmailFactory(labels);
    };

    const clearValues = () => {
        setUserId('');
        setFirstName('');
        setLastName('');
        setEmail('');
        setTelephone('');
        setEmailFactory([]);
        setEmailCode("");
        setEmailNotify("");
        setCountry("");
        setgroupCode("");
    }


    const handleCountryChange = (event, newValue, reason) => {
        if (reason === 'clear')
            setCountry('');
        else
            countryList.filter(ele => ele.countryName.includes(newValue)).map(ele => setCountry(ele.countryName));
    }

    const handleGroupChange = (event, newValue, reason) => {
        newValue = (newValue === 'Factory User' ? 'factory_group' : 'admin_group');
        if (reason === 'clear')
            setgroupCode('');
        else
            group.filter(ele => ele.name.includes(newValue)).map(ele => setgroupCode(ele.groupId));
        if (newValue === 'admin_group') {
            document.getElementById("emailCodes").style.display = 'block';
            document.getElementById("multiple-limit-tags").style.display = 'none';
        } else {
            document.getElementById("emailCodes").style.display = 'none';
            document.getElementById("multiple-limit-tags").style.display = 'block';
        }

    }

    const handleEmailCodeChange = (event, newValue, reason) => {
        if (reason === 'clear')
            setEmailCode('');
        else
            emailCodeList.filter(ele => ele.name.includes(newValue)).map(ele => setEmailCode(ele.id));
    }

    const handleEmailNotifyChange = (event, newValue, reason) => {
        if (reason === 'clear')
            setEmailNotify('');
        else
            emailNotifyList.filter(ele => ele.includes(newValue)).map(ele => setEmailNotify(ele));
    }

    const handleGridUpdate = async () => {
        let vlabels = Object.keys(emailFactory).map(function (k) { return emailFactory[k] }).join(",");
        if (userId === '' || userId === "") {
            setAlertType('error')
            setAlertMessage("Please enter UserID")
            setOpen(true)
        } else if (firstName === '' || firstName === "") {
            setAlertType('error')
            setAlertMessage("Please enter First Name")
            setOpen(true)
        } else if (lastName === '' || lastName === "") {
            setAlertType('error')
            setAlertMessage("Please enter Last Name")
            setOpen(true)
        } else if (country === '' || country === "") {
            setAlertType('error')
            setAlertMessage("Select Country")
            setOpen(true)
        } else if (groupCode === '' || groupCode === "") {
            setAlertType('error')
            setAlertMessage("Select Group")
            setOpen(true)
        } else if (emailNotify === '' || emailNotify === "") {
            setAlertType('error')
            setAlertMessage("Select Email Notify")
            setOpen(true)
        } else if (email === '' || email === "") {
            setAlertType('error')
            setAlertMessage("Please enter email ID")
            setOpen(true)
        } else {
            handleUpdate();
        }
    }

    const handleUpdate = async () => {
        let vlabels = Object.keys(emailFactory).map(function (k) { return emailFactory[k] }).join(",");
        updateUser({

            "countryName": country,
            "email": email,
            "emailCode": emailCode,
            "emailFactory": vlabels,
            "emailNotify": emailNotify,
            "firstName": firstName,
            "groupCode": groupCode,
            "lastName": lastName,
            "liaisonOfficeCode": "01",
            "telephone": telephone,
            "userId": userId
        })
            .then(([response, json]) => {
                if (response.status === 200) {
                    if (json.results === undefined) {
                        setAlertType('error')
                        setAlertMessage("Please enter the details correctly")
                        setOpen(true)
                    }
                    else if (json.results[0] === 'SUCCESS') {
                        setAlertType('success')
                        setAlertMessage("User Updated Successfully")
                        setOpen(true)
                        clearValues()
                        closeModal(false)
                        dispatch(getUserListAction({ fetchSize: GRID_FETCH_SIZE, page: currentPage }))
                    } else {
                        setAlertType('error')
                        setAlertMessage(json.results[0])
                        setOpen(true)
                    }
                }
                else {
                    setAlertType('error')
                    setAlertMessage("Unable to Update User")
                    setOpen(true)
                }
            })
    }

    // Get display value for email code
    const getEmailCodeDisplayValue = () => {
        if (!emailCode) return '';
        const found = emailCodeList.find(ele => ele.id === emailCode);
        return found ? found.name : '';
    };

    // Get display value for user type
    const getUserTypeDisplayValue = () => {
        if (groupCode === 'G2') return 'Factory User';
        if (groupCode === 'G1') return 'Admin User';
        return '';
    };

    return (
        <>
            <SimpleSnackbar setOpen={setOpen} open={open} message={alertMessage} messagetype={alertType} />
            <Modal
                open={openModal}
                onClose={() => { }}
                disableEscapeKeyDown
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styles.popupStyle} style={{ overflowY: 'scroll' }}>
                    <Typography component='div' style={styles.popupContent.title}>
                        <Typography component='span' style={styles.popupContent.titleText}>Edit User</Typography>
                        <IconButton id="close-modal-popup" data-testid="close-modal-popup" onClick={() => { closeModal(false) }} style={styles.popupContent.closeButton}>
                            <CloseIcon />
                        </IconButton>
                    </Typography>

                    <Stack>
                        <Box sx={styles.popupContent.row}>

                            <TextField
                                type={'text'}
                                style={{ width: 230 }}
                                label='User ID'
                                value={userId}
                                disabled={true}
                                variant="outlined"
                            />

                            <TextField
                                type={'text'}
                                style={{ width: 230 }}
                                label='First Name'
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                variant="outlined"
                            />

                        </Box>





                        <Box sx={styles.popupContent.row}>
                            <TextField
                                type={'text'}
                                style={{ width: 230 }}
                                label='Last Name'
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                variant="outlined"
                            />

                            <Autocomplete
                                id="customer"
                                value={getUserTypeDisplayValue()}
                                options={group.map(ele => ele.name === 'factory_group' ? 'Factory User' : 'Admin User')}
                                onChange={(e25, newValue25, reason25) => handleGroupChange(e25, newValue25, reason25)}
                                style={{ width: 230 }}
                                renderInput={(params25) => (
                                    <TextField {...params25} label="User Type" variant="outlined" />
                                )}
                            />
                        </Box>


                        <Box sx={styles.popupContent.row}>
                            <TextField
                                type={'text'}
                                style={{ width: "230px" }}
                                label='Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                variant="outlined"
                            />
                            <Autocomplete
                                id="product-group"
                                value={emailNotify}
                                options={emailNotifyList.map(ele => ele)}
                                onChange={(e21, newValue21, reason21) => handleEmailNotifyChange(e21, newValue21, reason21)}
                                style={{ width: 230 }}
                                renderInput={(params21) => (
                                    <TextField {...params21} label="Email Notify" variant="outlined" />
                                )}
                            />

                        </Box>

                        <Box sx={styles.popupContent.row}>
                            <TextField
                                type={'text'}
                                style={{ width: "230px" }}
                                label='Telephone Number'
                                value={telephone}
                                onChange={(e) => setTelephone(e.target.value)}
                                variant="outlined"
                            />

                            <Autocomplete
                                id="specialdescription"
                                value={country}
                                options={countryList.map(ele => ele.countryName)}
                                onChange={(e24, newValue24, reason24) => handleCountryChange(e24, newValue24, reason24)}
                                style={{ width: 230 }}
                                renderInput={(params24) => (
                                    <TextField {...params24} label="Country" variant="outlined" />
                                )}
                            />

                        </Box>

                        <div id="emailCodes">
                            <Box sx={styles.popupContent.row} >

                                <Autocomplete
                                    value={getEmailCodeDisplayValue()}
                                    options={emailCodeList.map(ele => ele.name)}
                                    onChange={(e22, newValue22, reason22) => handleEmailCodeChange(e22, newValue22, reason22)}
                                    style={{ width: 480 }}
                                    renderInput={(params22) => (
                                        <TextField {...params22} label="Approval Notification for Division" variant="outlined" />
                                    )}
                                />

                            </Box>
                            <Typography component='div' style={styles.approvalInfo}>
                                <Typography style={styles.approvalTitle} component="span">{ORDERS.EmailCodenote}</Typography>
                            </Typography>
                        </div>
                        <div id="multiple-limit-tags">
                            <Box sx={styles.popupContent.row}>
                                <Autocomplete
                                    multiple
                                    limitTags={2}
                                    value={emailFactory}
                                    options={factoryList.map(ele => ele.factoryCode)}
                                    onChange={(event, newValues23) => {
                                        callbackFromMultiSelect(newValues23);
                                    }}
                                    renderInput={(params23) => (
                                        <TextField {...params23} label="Approval Notification for Factories" />
                                    )}
                                    sx={{ width: '480px' }}
                                />
                            </Box>

                            <Typography component='div' style={styles.approvalInfo}>
                                <Typography style={styles.approvalTitle} component="span">{ORDERS.EmailFactorynote}</Typography>
                            </Typography>
                        </div>

                        <Box sx={styles.popupContent.button}>
                            <OrderButton onClick={handleGridUpdate}>Save Changes</OrderButton>
                        </Box>

                    </Stack>
                </Box>
            </Modal>
        </>
    )
}

export default EditLabelUser;
